import core from './commuCore'
const output = {}

// 新增
function createArticle (data) {
  return core.ajax(data, '/article/', 'post')
}
output.createArticle = createArticle

// 修改
function updateArticle (data) {
  return core.ajax(data, '/article/', 'put')
}
output.updateArticle = updateArticle

// 获取列表
function getArticlePage (data) {
  return core.ajax(data, '/article/', 'get')
}
output.getArticlePage = getArticlePage

// 删除文章
function deleteArticle (articleId) {
  return core.ajax(articleId, '/article/', 'delete')
}
output.deleteArticle = deleteArticle

export default output
